import { Observable } from 'rxjs';
import { Specialization, DataSourceResponse} from '../../models';
import { Injectable } from '@angular/core';
import { ApiService } from '@meddatacore/common';
import { HttpParamsEncoder } from '../../tools';


@Injectable({ providedIn: 'root' })
export class SpecializationService extends ApiService {
  endPoint = '/api/specializations';
  create(model: Specialization) {
    return this.http.post(`${this.commonBaseURL}${this.endPoint}`, model);
  }

  update(id: string, model: Specialization) {
    return this.http.put(`${this.commonBaseURL}${this.endPoint}/${id}`, model);
  }

  delete(id: string) {
    return this.http.delete<any>(`${this.commonBaseURL}${this.endPoint}/${id}`);
  }
  deleteRange(ids: string[]) {
    return this.http.post<any>(`${this.commonBaseURL}${this.endPoint}/deleteRange`, ids);
  }

  get(id: string): Observable<Specialization> {
    return this.http.get<Specialization>(`${this.commonBaseURL}${this.endPoint}/${id}`);
  }

  getList(queryParams: any): Observable<DataSourceResponse<Specialization>> {
    const params = new HttpParamsEncoder().encode(queryParams);

    return this.http.get<any>(`${this.commonBaseURL}${this.endPoint}`, { params });
  }

  getAll(queryParams: any): Observable<Specialization[]> {
    const params = new HttpParamsEncoder().encode(queryParams);
    return this.http.get<any>(`${this.commonBaseURL}${this.endPoint}/all`, { params });
  }
}
